(function (angular) {
    angular
        .module('one.admin')
        .controller('AddImportController', AddImportController);

    AddImportController.$inject = ['$scope', '$state', 'http', 'Upload'];

    function AddImportController($scope, $state, http, Upload) {
        $scope.uploads = [];

        $scope.upload = function (files) {
            if (files && files.length > 0) {
                var progress = function (evt) {
                    $scope.uploads[this.id].progress = parseInt(100.0 * evt.loaded / evt.total, 10);
                };

                var success = function (data, status, headers, config) {
                    $scope.uploads[this.id].file = data;

                    $state.transitionTo('imports.import', {importId: data.import.id});
                };

                var error = function (data, status, headers, config) {
                    $scope.uploads[this.id].errors = data.errors;
                };

                for (var i = 0; i < files.length; i++) {
                    var file = files[i];

                    var id = $scope.uploads.length;

                    $scope.uploads[id] = { binary: file, progress: 0 };

                    Upload.upload({
                        url: http.getPath('imports/add'),
                        file: file
                    })
                    .progress(progress.bind({ id: id }))
                    .success(success.bind({ id: id }))
                    .error(error.bind({ id: id }));
                }
            }
        };
    }
})(angular);
